import React, { useState } from "react"

// Uses react-spring to animate a pulse
import { useSpring, animated } from 'react-spring'

const Pulse = ({ ...props }) => {
    const { show, color, size } = props

    const backgroundColor = '#FF00FF'
    const offsetLeft = 12
    const offsetTop = 10

    const baseSyles = {
        position: 'absolute',
        borderRadius: '10em',
        backgroundColor: backgroundColor,
        height: size,
        width: size,
        left: '50%',
        top: '50%',
        marginLeft: `1.4rem`,
        marginTop: `1.8rem`,
        textAlign: 'center',
        transform: 'translate(-50%, -50%)'
    }

    // Transition form 0 to 1
    const { x } = useSpring({
        from: { x: 0 },
        to: async (next, cancel) => {
            await next({ x: 1 })
            await next({ x: 5 })
            await next({ x: 2 })
            await next({ x: 3.5 })
            await next({ x: 2 })
            await next({ x: 4 })
            await next({ x: 1 })
        },
        config: {
            duration: 800
        },
        //reset: true
    })

    //console.log('radians: ', radians.value)
    const translateMarker = `translate(-50%, -90%)`
    return (
        <animated.div
            className='marker-pulse'
            style={{
                ...baseSyles,
                opacity: x.interpolate({
                    range: [0, 10],
                    output: [0.1, 0.2]
                }),
                transform: x.interpolate(x => `${translateMarker} scale(${x})`),
                height: size,
                width: size,
            }} />
    )
}

Pulse.defaultProps = {
    color: '#000000',
    size: '3rem',
    show: true,
}

export default Pulse
